import { __read } from "tslib";
import React, { isValidElement, useState } from 'react';
import darkTheme from './rcDark.json';
import highContrast from './rcHighContrast.json';
import { RcThemeContext } from './ThemeContext';
export var RcDefaultDarkTheme = darkTheme;
export var RcDefaultHighContrastTheme = highContrast;
export var RcThemeSwitcherDefaultTheme = {
    defaultTheme: 'light',
    themeMap: {
        light: {},
    },
};
export var RcThemeSwitcherProvider = function (_a) {
    var children = _a.children, _b = _a.defaultTheme, defaultTheme = _b === void 0 ? RcThemeSwitcherDefaultTheme.defaultTheme : _b, _c = _a.themeMap, themeMap = _c === void 0 ? RcThemeSwitcherDefaultTheme.themeMap : _c;
    var _d = __read(useState(defaultTheme), 2), currentTheme = _d[0], setTheme = _d[1];
    return (React.createElement(RcThemeContext.Provider, { value: {
            defaultTheme: defaultTheme,
            themeMap: themeMap,
            theme: currentTheme,
            setTheme: setTheme,
        } },
        React.createElement(RcThemeContext.Consumer, null, function (_a) {
            var theme = _a.theme, themeMap = _a.themeMap;
            Object.keys(themeMap).forEach(function (key) {
                document.body.removeAttribute(key);
            });
            document.body.setAttribute(theme, '');
            if (isValidElement(children)) {
                var _children = React.cloneElement(children, {
                    theme: themeMap[theme],
                });
                return _children;
            }
            throw new Error('RcThemeSwitcherProvider can only have one children with theme props');
        })));
};
